<template>
  <div id="main-wrapper">
    <NavbarDark />

    <section class="gray-simple">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6 col-md-8">
            <div class="log-in-box">
              <div class="log-in-box-header">
                <h3>Login To Your Account</h3>
              </div>
              <div class="log-in-box-body">
                <form @submit.prevent="handleLogin">
                  <div class="form-group">
                    <label class="mb-1">Email Address</label>
                    <input type="email" class="form-control" v-model="email" required>
                  </div>
                  <div class="form-group mt-3">
                    <label class="mb-1">Password</label>
                    <input type="password" class="form-control" v-model="password" required>
                  </div>
                  <div class="form-group mt-4">
                    <button type="submit" class="btn btn-primary fw-medium px-5" :disabled="loading">
                      {{ loading ? 'Logging in...' : 'Login' }}
                    </button>
                  </div>
                  <div v-if="error" class="alert alert-danger mt-3">
                    {{ error }}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <FooterDark />
    <ScrollToTop />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import NavbarDark from '@/components/navbar/navbar-dark.vue';
import FooterDark from '@/components/footer/footer-dark.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'; // Import useStore

const router = useRouter();
const store = useStore(); // Get the store instance
const email = ref('');
const password = ref('');
const loading = ref(false);
const error = ref('');

const handleLogin = async () => {
  loading.value = true;
  error.value = '';

  try {
    // Dispatch the login action from the Vuex store
    await store.dispatch('auth/login', {
      email: email.value,
      password: password.value
    });
    // On success, redirect to the home page
    router.push('/');
  } catch (err) {
    // Handle Firebase auth errors
    switch (err.code) {
      case 'auth/user-not-found':
      case 'auth/wrong-password':
      case 'auth/invalid-credential':
        error.value = 'Invalid email or password.';
        break;
      default:
        error.value = 'An unexpected error occurred. Please try again.';
        break;
    }
    console.error(err);
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.log-in-box {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-top: 40px;
  margin-bottom: 40px;
}
.log-in-box-header {
  background: #f7f7f7;
  padding: 20px;
  border-bottom: 1px solid #eee;
  text-align: center;
}
.log-in-box-body {
  padding: 30px;
}
</style>